import { $http } from '@/utils';

/**
 * @namespace Service
 * @class Panel
 * @exports Service/Account/Panel
 * @description API Organisation Service
 * @date 2021/04/01
 * @license no license
 * @copywrite Answers In Retirement Limited
 */
export default class Panel {
	/**
	 * @static @name post
	 * @description Add a new Organisation Panel resource
	 * @param {Object} payload
	 * @returns {Object} Promise a http response
	 */
	static post(payload) {
		return $http.post(`account/organisation/panel`, payload);
	}

	/**
	 * @static @name patch
	 * @description Edit an Organisation Panel resource
	 * @param {UUID} id
	 * @param {Object} payload
	 * @returns {Object} Promise a http response
	 */
	static patch(id, payload) {
		return $http.patch(`account/organisation/panel/${id}`, payload);
	}

		/**
	 * @static @name post
	 * @description Get an organisation's list of panels
	 * @param {Object} payload
	 * @returns {Object} Promise a http response
	 */
	static list(payload) {
		return $http.post(`account/organisation/panel/list`, payload);
	}


	/**
	 * @static @name get
	 * @description Get all a panel with details
	 * @param {Object} payload
	 * @returns {Object} Promise a http response
	 */
	static get(id) {
		return $http.get(`account/organisation/panel/${id}`);
	}

	/**
	 * @static @name delete
	 * @description Hard delete Organisation details for ID
	 * @param {String} id
	 * @returns {Object} Promise a http response
	 */
	static delete(id) {
		return $http.delete(`account/organisation/panel/${id}`);
	}

}
